import { Route, Routes } from "react-router-dom";

import Container from "./hooks/Container";
import LoggInn from "./pages/LoggInn";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";

import Home from "./pages/Home";
import { News, NewsArticle } from "./pages/News";
import Tournament from "./pages/Tournament";
import Gallery from "./pages/Gallery";
import { StatPlayer, Stats } from "./pages/Stats";

import { useEffect, useState } from "react";

function App() {
  const [token, setToken] = useState(() => localStorage.getItem("jwtToken"));
  const [isLoggedIn, setLoggedIn] = useState(false);

  const checkLoginStatus = async () => {
    if (!token) {
      setLoggedIn(false);
      return;
    }
    try {
      const res = await fetch("https://auth.eakz.no/auth", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });

      if (res.ok) {
        // valider token, sett loggedIn til true
        setLoggedIn(true);
      } else {
        // Token ugyldig, fjern token og logg ut
        setLoggedIn(false);
        setToken(null);
        localStorage.removeItem("jwtToken");
      }
    } catch (err) {
      console.error("Error checking login status:", err);
      setLoggedIn(false);
      setToken(null);
      localStorage.removeItem("jwtToken");
    }
  };

  useEffect(() => {
    let interval;

    const startCheck = async () => {
      await checkLoginStatus();
      interval = setInterval(checkLoginStatus, 15000);
    };

    startCheck();

    return () => clearInterval(interval);
  }, [token]);

  // Logout-funksjon
  const logout = () => {
    setToken(null);
    setLoggedIn(false);
    localStorage.removeItem("jwtToken");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Tournament isLoggedIn={isLoggedIn} token={token} />
          </Container>
        }
      />
      <Route
        path="/:id"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Tournament isLoggedIn={isLoggedIn} token={token} />
          </Container>
        }
      />
      <Route
        path="/auth/callback"
        element={<AuthCallback setToken={setToken} />}
      />
      <Route
        path="/logginn"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <LoggInn
              isLoggedIn={isLoggedIn}
              checkLoginStatus={checkLoginStatus}
            />
          </Container>
        }
      />
      {isLoggedIn && (
        <Route
          path="/admin/:page?/:subpage?"
          element={
            <Container isLoggedIn={isLoggedIn}>
              <Admin isLoggedIn={isLoggedIn} token={token} />
            </Container>
          }
        />
      )}
      <Route
        path="/nyheter"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <News isLoggedIn={isLoggedIn} />
          </Container>
        }
      />
      <Route
        path="/nyheter/:id"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <NewsArticle isLoggedIn={isLoggedIn} />
          </Container>
        }
      />
      <Route
        path={"/tour"}
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Tournament isLoggedIn={isLoggedIn} token={token} />
          </Container>
        }
      />
      <Route
        path="/tour/:id"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Tournament isLoggedIn={isLoggedIn} token={token} />
          </Container>
        }
      />
      <Route
        path="/stats"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Stats isLoggedIn={isLoggedIn} />
          </Container>
        }
      />
      <Route
        path="/stats/:player"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <StatPlayer isLoggedIn={isLoggedIn} />
          </Container>
        }
      />
      <Route
        path="/galleri"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Gallery isLoggedIn={isLoggedIn} />
          </Container>
        }
      />
      <Route
        path="/galleri/:id"
        element={
          <Container isLoggedIn={isLoggedIn}>
            <Gallery isLoggedIn={isLoggedIn} />
          </Container>
        }
      />
    </Routes>
  );
}

export default App;
